<div class="menu" [ngClass]="{ 'menu--collapsed': menuState === 'collapsed' }">
  <div class="logo">
    <a routerLink="/" class="logo__image"></a>
  </div>
  <div class="list">
    <div class="list__toggle" (click)="toggleMenu()">
      <span class="material-symbols-outlined">
        {{ 'keyboard_arrow_' }}{{ menuState === 'expanded' ? 'left' : 'right' }}
      </span>
    </div>
    <div class="list__items">
      @if (availableModules$ | async; as availableModules) {
        @for (item of menuItems; track item.label) {
          @if (isItemVisible(item, availableModules)) {
            @if (item.children?.length) {
              <div
                class="list__item list__item--toggle"
                [class.list__item--open]="isExpanded(item)"
                (click)="toggleSubmenu(item, $event)"
                (mouseenter)="openFlyout(groupFlyoutTrigger)"
                (mouseleave)="scheduleFlyoutClose(groupFlyoutTrigger)">
                <mat-icon fontSet="material-symbols-outlined">{{ item.icon }}</mat-icon>
                <span [ngClass]="{ 'list__item--collapsed': menuState === 'collapsed' }" class="list__item--label">{{
                  item.label
                }}</span>
                @if (menuState !== 'collapsed') {
                  <mat-icon
                    class="material-symbols-outlined list__item--chevron"
                    [class.list__item--chevron-open]="isExpanded(item)"
                    >expand_more</mat-icon
                  >
                }
                <!--
                  The collapsed rail's flyout hangs off this zero-width anchor at the row's right edge rather than
                  off the row itself: Material anchors a plain (non-submenu) overlay's own LEFT edge to the trigger's
                  LEFT edge, so a row-anchored overlay pane would sit on top of the icon and steal its hover (see
                  .list__item--flyout-anchor in the SCSS). Hover handling stays on the row above; this element only
                  positions the overlay.
                -->
                <span
                  class="list__item--flyout-anchor"
                  aria-hidden="true"
                  [matMenuTriggerFor]="menuState === 'collapsed' ? groupFlyout : null"
                  #groupFlyoutTrigger="matMenuTrigger"></span>
              </div>
              <div class="list__tray" [style.max-height.px]="isExpanded(item) ? childTrayMaxHeight(item) : 0">
                <div class="list__tray-inner">
                  @for (child of visibleChildren(item, availableModules); track child.label) {
                    @if (child.isInternalUrl) {
                      <a
                        class="list__item--child"
                        [routerLink]="child.path"
                        routerLinkActive="list__item--child-active">
                        {{ child.label }}
                      </a>
                    } @else {
                      <a class="list__item--child" [href]="child.claimName | urlPerEnvironment" target="_blank">
                        {{ child.label }}
                      </a>
                    }
                  }
                </div>
              </div>

              <mat-menu
                #groupFlyout="matMenu"
                class="list__group-flyout"
                xPosition="after"
                yPosition="below"
                [overlapTrigger]="true"
                [hasBackdrop]="false">
                <div
                  class="list__group-flyout-panel"
                  (mouseenter)="cancelFlyoutClose()"
                  (mouseleave)="scheduleFlyoutClose(groupFlyoutTrigger)">
                  <div class="list__group-flyout-header">
                    <mat-icon fontSet="material-symbols-outlined">{{ item.icon }}</mat-icon>
                    <span>{{ item.label }}</span>
                  </div>
                  <div class="list__group-flyout-tray">
                    @for (child of visibleChildren(item, availableModules); track child.label) {
                      @if (child.isInternalUrl) {
                        <a
                          mat-menu-item
                          class="list__group-flyout-item"
                          [routerLink]="child.path"
                          routerLinkActive="list__group-flyout-item-active">
                          {{ child.label }}
                        </a>
                      } @else {
                        <a
                          mat-menu-item
                          class="list__group-flyout-item"
                          [href]="child.claimName | urlPerEnvironment"
                          target="_blank">
                          {{ child.label }}
                        </a>
                      }
                    }
                  </div>
                </div>
              </mat-menu>
            } @else if (item.isInternalUrl) {
              <a
                class="list__item"
                [routerLink]="item.path"
                routerLinkActive="list__item--active"
                [matTooltip]="item.label"
                [matTooltipDisabled]="menuState !== 'collapsed'"
                matTooltipPosition="right">
                <mat-icon fontSet="material-symbols-outlined">{{ item.icon }}</mat-icon>
                <span [ngClass]="{ 'list__item--collapsed': menuState === 'collapsed' }" class="list__item--label">{{
                  item.label
                }}</span>
              </a>
            } @else {
              <a
                class="list__item"
                [href]="item.claimName | urlPerEnvironment"
                target="_blank"
                [matTooltip]="item.label"
                [matTooltipDisabled]="menuState !== 'collapsed'"
                matTooltipPosition="right">
                <img
                  class="list__item--external-url-icon"
                  ngSrc="/icons/sgl_arrows_white.png"
                  alt="sgl arrows"
                  height="13"
                  width="18" />
                <span [ngClass]="{ 'list__item--collapsed': menuState === 'collapsed' }" class="list__item--label">{{
                  item.label
                }}</span>
              </a>
            }
          }
        }
      }
    </div>
    @if (userInfo$ | async; as userInfo) {
      <div class="list__footer" [matMenuTriggerFor]="userMenu" #userMenuTrigger="matMenuTrigger">
        <div class="list__user">
          <app-avatar
            class="list__user--avatar"
            [size]="36"
            [displayName]="userInfo.displayName"
            [photoUrl]="userInfo.photoUrl ?? null"></app-avatar>
          <div [ngClass]="{ 'list__item--collapsed': menuState === 'collapsed' }" class="list__user--info">
            <span class="list__user--name" [appEllipsisTooltip]="userInfo.displayName">{{ userInfo.displayName }}</span>
            @if (userInfo.jobRole) {
              <span class="list__user--role" [appEllipsisTooltip]="userInfo.jobRole">{{ userInfo.jobRole }}</span>
            }
          </div>
          @if (menuState !== 'collapsed') {
            <mat-icon
              class="material-symbols-outlined list__user--chevron"
              [class.list__user--chevron-open]="userMenuTrigger.menuOpen"
              >expand_more</mat-icon
            >
          }
        </div>
        <mat-menu #userMenu="matMenu" class="list__user-menu" yPosition="above" xPosition="after">
          <button mat-menu-item class="list__user-menu-item" (click)="logout()">
            <mat-icon class="material-symbols-outlined">logout</mat-icon>
            <span>Log out</span>
          </button>
        </mat-menu>
      </div>
    }
  </div>
</div>
